import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import {Route, Routes} from "react-router-dom"
import {BrowserRouter as Router} from "react-router-dom"
import AccessPage from './pages/access/AccessPage'

import LogoutPage from './pages/auth/logout'
import ClientPage from './pages/client/client'
import CurvasPage from './v2/pages/Curvas/curvas'
import CurvesDTSPage from './pages/curves/curves-dts'
import CurvesSetorialPage from './pages/curves/curves-setorial'
import CurvesSubsetorialPage from './pages/curves/curves-subsetorial'
import CurvesSpreadPage from './pages/curves/curves-spread'
import CurvesTirPage from './pages/curves/curves-tir'
import NotFound from './pages/default/not-found'
import WithoutPermissionPage from './pages/default/without-permission'
import ImportDataPage from './pages/import/import-data-page'
import DeleteDataPage from './pages/import/delete-data-page'
import CustomersPriceLogPage from './v2/pages/Prices/PrecosLog/precos-log-page'
import ProfilePage from './pages/user/profile'
import UserPage from './pages/user/user'
import ConcessionsPage from './pages/receivable-management/concessions'
import WalletsPage from './pages/receivable-management/wallets'
import MarketRatesPage from './pages/receivable-management/market-rates'
import ParametersPage from './pages/receivable-management/parameters'

import {
    CLIENT_PAGE,
    CURVES_PAGE,
    CURVES_SPREAD_PAGE,
    CURVES_TIR_PAGE,
    HOME_PAGE,
    INDEX_PAGE,
    LOGOUT_PAGE,
    PRICES_PAGE,
    RECOVER_PASSWORD_PAGE,
    REGISTER_PASSWORD_PAGE,
    PROFILE_PAGE,
    USER_PAGE,
    CURVES_SETORIAL_PAGE,
    CURVES_SUBSETORIAL_PAGE,
    CURVES_DTS_PAGE,
    IMPORT_PAGE,
    PRICES_TABLE_BONDS_PAGE,
    CONCESSIONS_PAGE,
    WALLETS_PAGE,
    MARKET_RATES_PAGE,
    PARAMETERS_PAGE,
    ACCESS_PAGE,
    WITHOUT_PERMISSION_PAGE,
    INTEGRATION_WORKFLOW_PAGE,
    REPORT_DATA_WORKFLOW_PAGE,
    REPORT_DATA_ROUTINES_WORKFLOW_PAGE,
    INTEGRATION_PAGE,
    INTEGRATION_DATA_PAGE,
    DELETE_DATA_PAGE,
    PRICES_UPDATE_SPREADS,
    API_INTEGRATION_PAGE,
    PARAMETERS_CALC_PAGE,
    SUPPORT_PAGE,
    PARAMETERS_DATALAKE_PAGE,
    PRODUCT_PAGE,
    SIMULADOR_SUBORDINACAO_PAGE,
    CUSTOMERS_PRICE_LOG_PAGE,
    EMISSAO_PAGE,
    EMISSAO_V2_PAGE,
    RATER_HISTORICO_PAGE,
    RATER_CALCULADORA_PAGE,
    RATER_MERTON_PAGE,
    RATER_RELATORIO_PAGE,
    RATER_SETORIAL_PAGE,
    RATER_CONFIGURACOES_PAGE,
    EMPRESAS_PAGE,
    FIXED_INCOME_CALCULATOR_PAGE,
    CONTINGENCIA_PAGE,
    TRATAMENTO_SPREADS_PAGE,
    PROMPT_PAGE,
    MEMORIA_DE_CALCULO,
    MOTOR_CADASTRO_PAGE,
    MOTOR_CADASTRO_MANUAL_PAGE,
    STATUS_CADASTRO_PAGE,
    MOTOR_EVENTOS_PAGE,
    DESIGN_SYSTEM_PAGE,
    DESIGN_SYSTEM_BUTTON_PAGE,
    DESIGN_SYSTEM_TABLE_PAGE,
    DESIGN_SYSTEM_INPUT_PAGE,
    DESIGN_SYSTEM_SIDEBAR_PAGE,
    API_PUBLIC_PAGE,
    DESIGN_SYSTEM_SNACKBAR_PAGE,
    DESIGN_SYSTEM_DUPLA_CONFIRMACAO_PAGE,
    DESIGN_SYSTEM_MODAL_DUPLICAR_PAGE,
    DESIGN_SYSTEM_FORM_SECTION_PAGE,
    DESIGN_SYSTEM_STATUS_BADGE_PAGE,
    DESIGN_SYSTEM_STATUS_ICON_BADGE_PAGE,
    DESIGN_SYSTEM_FIELD_RENDERER_PAGE,
    DESIGN_SYSTEM_GRID_FORM_SHEET_PAGE,
    DESIGN_SYSTEM_INFO_DATA_PANEL_PAGE,
    DESIGN_SYSTEM_INFO_ITEM_PAGE,
    DESIGN_SYSTEM_SUMMARY_SECTION_PAGE,
    TREINAMENTO_MERCADO_PAGO_PAGE,
    DESIGN_SYSTEM_TABS_PAGE,
    METHODOLOGY_PAGE,
    MOTOR_EVENTOS_CADASTRO_PAGE,
    PUBLIC_ROUTES,
    MOTOR_CADASTRO_LOTE_PAGE,
    MEMORIA_DE_CALCULO_V2_PAGE,
    EMPRESAS_V2_PAGE
} from './utils/routes'
import * as serviceWorker from './utils/service-worker'
import ContingenciaPage from './v2/pages/Contingencia/contingencia'
import IntegrationWorkflowPage from './pages/integration/integration-workflow'
import ReportDataWorkflowPage from './pages/integration/report-data-workflow'
import ReportDataRoutinesWorkflowPage from './pages/integration/report-data-workflow'
import IntegrationPage from './pages/integration/integration'
import PriceUpdateSpreadsPage from './v2/pages/AtualizacaoSpreads/atualizacao-spreads'
import ApiPage from './pages/api/api'
import ParameterCalcPage from './pages/parameters/parameters-calc/parameter-calc'
import SupportPage from './pages/support/support'
import ParameterDatalakePage from './pages/parameters/parameters-datalake/parameter-datalake'
import ProductPage from './pages/product/product'
import PriceCharacteristics from './pages/prices/characteristcs/price-characteristics'
import SimuladorSubordinacaoPage from './pages/receivable-management/simulador-subordinacao/simulador-subordinacao'
import IntegrationDataPage from './pages/integration/integration-data'
import HistoricoRaterPage from './pages/rater/historico-rater'
import CalculadoraRaterPage from './pages/rater/calculadora-rater'
import MertonRaterPage from './pages/rater/merton-rater'
import RelatorioRaterPage from './pages/rater/relatorio-rater'
import SetorialRaterPage from './pages/rater/setorial-rater'
import ConfiguracoesRaterPage from './pages/rater/configuracoes-rater'
import EmpresasPage from './pages/empresas/empresas' //percente a v1
import FixedIncomeCalculatorPage from "./pages/price-change/fixed-income-calculator"
import PromptPage from './pages/prompt/prompt'
import CurvasCreditoWorkflowsPage from "./v2/pages/TratamentoSpreads/tratamento-spreads"

import LoginPage from "./v2/pages/Login/login"
import RecoverPasswordPage from "./v2/pages/RecoverPassword/recover-password"
import RegisterPasswordPage from "./v2/pages/RegisterPassword/register-password"
import HomePage from "./v2/pages/Home/home"
import DataLakeEmission from "./v2/pages/DatalakeEmission/data-lake-emission"
import DataLakeEmissionV2 from "./v2/pages/DatalakeEmissionv2/data-lake-emission"
import MotorCadastroListPage from "./v2/pages/MotorCadastros/CadastroCaracteristicas/cadastro"
import MotorCadastroManualPage from "./v2/pages/MotorCadastros/CadastroCaracteristicas/cadastro-manual"
import StatusCadastroPage from "./v2/pages/MotorCadastros/StatusCadastro/status-cadastro-page"
import DesignSystemPage from "./v2/pages/DesignSystem/design-system"
import ButtonsDesignSystemPage from "./v2/pages/DesignSystem/Buttons/buttons"
import TableDataGridPage from "./v2/pages/DesignSystem/Table/table-data-grid"
import InputPage from "./v2/pages/DesignSystem/Input/input"
import FormSectionsDesignSystemPage from "./v2/pages/DesignSystem/FormSections/form-sections"
import StatusBadgeDesignSystemPage from "./v2/pages/DesignSystem/StatusBadge/status-badge"
import StatusIconBadgeDesignSystemPage from './v2/pages/DesignSystem/StatusIconBadge/status-icon-badge'
import SideBarPage from "./v2/pages/DesignSystem/SideBar/sidebar"
import ApiPublicPage from "./pages/api/public_api"
import DuplaConfirmacaoDesignSystemPage from './v2/pages/DesignSystem/DuplaConfirmacao/duplaconfirmacao'
import ModalDuplicarDesignSystemPage from "./v2/pages/DesignSystem/ModalDuplicar/modal-duplicar"
import SnackbarPage from "./v2/pages/DesignSystem/SnackBar/snackbar"
import FieldRendererDesignSystemPage from "./v2/pages/DesignSystem/FieldRenderer/field-renderer"
import GridFormSheetDesignSystemPage from "./v2/pages/DesignSystem/GridFormSheet/grid-form-sheet"
import TreinamentoMercadoPagoPage from "./v2/pages/Treinamento/MercadoPago/treinamento-mercado-pago"
import TabsPage from "./v2/pages/DesignSystem/Tabs/tab"
import InfoDataPanelDesignSystemPage from "./v2/pages/DesignSystem/InfoDataPanel/info-data-panel"
import InfoItemDesignSystemPage from "./v2/pages/DesignSystem/InfoItem/info-item"
import SummarySectionDesignSystemPage from "./v2/pages/DesignSystem/SummarySection/summary-section"
import MotorCadastroEventosListPage from "./v2/pages/MotorCadastros/CadastroEventos/cadastro-eventos-list-page"
import MetodologiaPage from "./v2/pages/Methodology/metodologia"
import PrecosPuTirPage from "./v2/pages/TabelaPrecosPUTIR/precos-pu-tir"
import PrecosPuBondsPage from "./v2/pages/TabelaPrecosBonds/precos-pu-bonds"
import {TokenService} from "./services/token-service"
import MotorCadastroEventosPage from "./v2/pages/MotorCadastros/CadastroEventos/cadastro-eventos-page"
import MotorCadastroLotePage from "./v2/pages/MotorCadastros/CadastroLote/cadastro-lote-page"
import DataLakeCompany from "./v2/pages/DatalakeCompanies/data-lake-company"
import MemoriaCalculoV2 from "./v2/pages/Prices/memoria-calculo"
const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement)

const tokenService = new TokenService()

try {
    const currentPage = window.location.pathname
    const isPublicRoute = PUBLIC_ROUTES.includes(currentPage)

    if (!isPublicRoute) {
        tokenService.decodeToken()
    }
} catch (error) {
    const currentPage = window.location.pathname
    if (!PUBLIC_ROUTES.includes(currentPage) && currentPage !== INDEX_PAGE) {
        window.location.href = INDEX_PAGE
    }
}

root.render(
    <Router>
        <Routes>
            <Route path={CLIENT_PAGE} element={<ClientPage/>}/>
            <Route path={PRICES_TABLE_BONDS_PAGE} element={<PrecosPuBondsPage/>}/>
            <Route path={ACCESS_PAGE} element={<AccessPage/>}/>
            <Route path={PRODUCT_PAGE} element={<ProductPage/>}/>
            <Route path={PRICES_UPDATE_SPREADS} element={<PriceUpdateSpreadsPage/>}/>
            <Route path={MEMORIA_DE_CALCULO} element={<PriceCharacteristics/>}/>
            <Route path={CUSTOMERS_PRICE_LOG_PAGE} element={<CustomersPriceLogPage/>}/>
            <Route path={CURVES_PAGE} element={<CurvasPage/>}/>
            <Route path={CURVES_TIR_PAGE} element={<CurvesTirPage/>}/>
            <Route path={CURVES_SPREAD_PAGE} element={<CurvesSpreadPage/>}/>
            <Route path={CURVES_SETORIAL_PAGE} element={<CurvesSetorialPage/>}/>
            <Route path={CURVES_SUBSETORIAL_PAGE} element={<CurvesSubsetorialPage/>}/>
            <Route path={CURVES_DTS_PAGE} element={<CurvesDTSPage/>}/>
            <Route path={IMPORT_PAGE} element={<ImportDataPage/>}/>
            <Route path={CONTINGENCIA_PAGE} element={<ContingenciaPage/>}/>
            <Route path={TRATAMENTO_SPREADS_PAGE} element={<CurvasCreditoWorkflowsPage/>}/>
            <Route path={INTEGRATION_WORKFLOW_PAGE} element={<IntegrationWorkflowPage/>}/>
            <Route path={REPORT_DATA_WORKFLOW_PAGE} element={<ReportDataWorkflowPage/>}/>
            <Route path={REPORT_DATA_ROUTINES_WORKFLOW_PAGE} element={<ReportDataRoutinesWorkflowPage/>}/>
            <Route path={INTEGRATION_DATA_PAGE} element={<IntegrationDataPage/>}/>
            <Route path={INTEGRATION_PAGE} element={<IntegrationPage/>}/>
            <Route path={DELETE_DATA_PAGE} element={<DeleteDataPage/>}/>
            <Route path={USER_PAGE} element={<UserPage/>}/>
            <Route path={PROFILE_PAGE} element={<ProfilePage/>}/>
            <Route path={SUPPORT_PAGE} element={<SupportPage/>}/>
            <Route path={LOGOUT_PAGE} element={<LogoutPage/>}/>
            <Route path={CONCESSIONS_PAGE} element={<ConcessionsPage/>}/>
            <Route path={WALLETS_PAGE} element={<WalletsPage/>}/>
            <Route path={SIMULADOR_SUBORDINACAO_PAGE} element={<SimuladorSubordinacaoPage/>}/>
            <Route path={MARKET_RATES_PAGE} element={<MarketRatesPage/>}/>
            <Route path={PARAMETERS_PAGE} element={<ParametersPage/>}/>
            <Route path={PARAMETERS_CALC_PAGE} element={<ParameterCalcPage/>}/>
            <Route path={PARAMETERS_DATALAKE_PAGE} element={<ParameterDatalakePage/>}/>
            <Route path={FIXED_INCOME_CALCULATOR_PAGE} element={<FixedIncomeCalculatorPage/>}/>
            <Route path={RATER_HISTORICO_PAGE} element={<HistoricoRaterPage/>}/>
            <Route path={RATER_CALCULADORA_PAGE} element={<CalculadoraRaterPage/>}/>
            <Route path={RATER_MERTON_PAGE} element={<MertonRaterPage/>}/>
            <Route path={RATER_RELATORIO_PAGE} element={<RelatorioRaterPage/>}/>
            <Route path={RATER_SETORIAL_PAGE} element={<SetorialRaterPage/>}/>
            <Route path={RATER_CONFIGURACOES_PAGE} element={<ConfiguracoesRaterPage/>}/>
            <Route path={EMPRESAS_PAGE} element={<EmpresasPage/>}/>
            <Route path={PROMPT_PAGE} element={<PromptPage/>}/>

            {/* v2 */}
            <Route path={EMISSAO_PAGE} element={<DataLakeEmission/>}/>
            <Route path={EMISSAO_V2_PAGE} element={<DataLakeEmissionV2/>}/>
            <Route path={MEMORIA_DE_CALCULO_V2_PAGE} element={<MemoriaCalculoV2/>}/>
            <Route path={EMPRESAS_V2_PAGE} element={<DataLakeCompany/>}/>

            <Route path={API_INTEGRATION_PAGE} element={<ApiPage/>}/>
            <Route path={API_PUBLIC_PAGE} element={<ApiPublicPage/>}/>

            <Route path={INDEX_PAGE} element={<LoginPage/>}/>
            <Route path={WITHOUT_PERMISSION_PAGE} element={<WithoutPermissionPage/>}/>
            <Route path={RECOVER_PASSWORD_PAGE} element={<RecoverPasswordPage/>}/>
            <Route path={REGISTER_PASSWORD_PAGE} element={<RegisterPasswordPage/>}/>
            <Route path={HOME_PAGE} element={<HomePage/>}/>
            <Route path={MOTOR_CADASTRO_PAGE} element={<MotorCadastroListPage/>}/>
            <Route path={MOTOR_CADASTRO_MANUAL_PAGE} element={<MotorCadastroManualPage/>}/>
            <Route path={STATUS_CADASTRO_PAGE} element={<StatusCadastroPage/>}/>

            <Route path={MOTOR_EVENTOS_PAGE}>
                <Route index element={<MotorCadastroEventosListPage/>}/>
                <Route path={MOTOR_EVENTOS_CADASTRO_PAGE} element={<MotorCadastroEventosPage/>}/>
            </Route>
            <Route path={MOTOR_CADASTRO_LOTE_PAGE} element={<MotorCadastroLotePage/>}/>

            {/* Precos */}
            <Route path={PRICES_PAGE} element={<PrecosPuTirPage/>}/>

            {/* Design System */}
            <Route path={DESIGN_SYSTEM_PAGE} element={<DesignSystemPage/>}/>
            <Route path={DESIGN_SYSTEM_BUTTON_PAGE} element={<ButtonsDesignSystemPage/>}/>
            <Route path={DESIGN_SYSTEM_TABLE_PAGE} element={<TableDataGridPage/>}/>
            <Route path={DESIGN_SYSTEM_INPUT_PAGE} element={<InputPage/>}/>
            <Route path={DESIGN_SYSTEM_SIDEBAR_PAGE} element={<SideBarPage/>}/>
            <Route path={DESIGN_SYSTEM_DUPLA_CONFIRMACAO_PAGE} element={<DuplaConfirmacaoDesignSystemPage/>}/>
            <Route path={DESIGN_SYSTEM_MODAL_DUPLICAR_PAGE} element={<ModalDuplicarDesignSystemPage/>}/>
            <Route path={DESIGN_SYSTEM_FORM_SECTION_PAGE} element={<FormSectionsDesignSystemPage/>}/>
            <Route path={DESIGN_SYSTEM_STATUS_BADGE_PAGE} element={<StatusBadgeDesignSystemPage/>}/>
            <Route path={DESIGN_SYSTEM_STATUS_ICON_BADGE_PAGE} element={<StatusIconBadgeDesignSystemPage/>}/>
            <Route path={DESIGN_SYSTEM_SNACKBAR_PAGE} element={<SnackbarPage/>}/>
            <Route path={DESIGN_SYSTEM_FIELD_RENDERER_PAGE} element={<FieldRendererDesignSystemPage/>}/>
            <Route path={DESIGN_SYSTEM_GRID_FORM_SHEET_PAGE} element={<GridFormSheetDesignSystemPage/>}/>
            <Route path={DESIGN_SYSTEM_TABS_PAGE} element={<TabsPage/>}/>
            <Route path={DESIGN_SYSTEM_INFO_DATA_PANEL_PAGE} element={<InfoDataPanelDesignSystemPage/>}/>
            <Route path={DESIGN_SYSTEM_INFO_ITEM_PAGE} element={<InfoItemDesignSystemPage/>}/>
            <Route path={DESIGN_SYSTEM_SUMMARY_SECTION_PAGE} element={<SummarySectionDesignSystemPage/>}/>

            {/* Treinamento */}
            <Route path={TREINAMENTO_MERCADO_PAGO_PAGE} element={<TreinamentoMercadoPagoPage/>}/>

            {/* Metodologia */}
            <Route path={METHODOLOGY_PAGE} element={<MetodologiaPage/>}/>

            <Route path="*" element={<NotFound/>}/>
        </Routes>
    </Router>
)

serviceWorker.unregister()